import { ReactComponent as SurveyDesignSupportIcon } from "./assets/side-nav/Questionnaire Support.svg";
import { ReactComponent as SurveyProgrammingIcon } from "./assets/side-nav/Survey Programming.svg";
import { ReactComponent as TranslationsIcon } from "./assets/side-nav/Translations.svg";
import { ReactComponent as DataCollectionIcon } from "./assets/side-nav/Data Collection.svg";
import { ReactComponent as DataAnalysisIcon } from "./assets/side-nav/Data Analysis.svg";
import { ReactComponent as DashboardIcon } from "./assets/side-nav/Dashboarding.svg";
import { ReactComponent as ReportsIcon } from "./assets/side-nav/Reports.svg";

export const MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY = {
  SURVEY_DESIGN_SUPPORT: 'surveyDesignSupport',
  SURVEY_PROGRAMMING: 'surveyProgramming',
  TRANSLATION: 'translation',
  DATA_COLLECTION: 'dataCollection',
  DATA_ANALYSIS: 'dataAnalysis',
  DASHBOARD: 'dashboard',
  REPORTS: 'reports',
}
export const endClientProjectDetailData = [
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.SURVEY_DESIGN_SUPPORT,
    label: 'Survey Design Support',
    icon: <SurveyDesignSupportIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.SURVEY_PROGRAMMING,
    label: 'Survey Programming',
    icon: <SurveyProgrammingIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.TRANSLATION,
    label: 'Translation',
    icon: <TranslationsIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.DATA_COLLECTION,
    label: 'Data Collection',
    icon: <DataCollectionIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.DATA_ANALYSIS,
    label: 'Data Analysis',
    icon: <DataAnalysisIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.DASHBOARD,
    label: 'Dashboarding',
    icon: <DashboardIcon />,
    approved: false,
  },
  {
    id: MARKET_RESEARCH_FULL_SERVICE_PROJECT_DETAIL_SIDE_MENU_KEY.REPORTS,
    label: 'Reports',
    icon: <ReportsIcon />,
    approved: false,
  },
]
